module.exports = __webpack_public_path__ + "img/ethos_gold_logo.c9d3ea62.png";